import React from "react";
import moment from "moment";
import { reportConfig } from "../../config/reportConfig";
import { getValue } from "../../utils/getValue";
import "../../assets/scss/custom.scss";
import { Card, CardBody } from "reactstrap";
import "chart.js/dist/Chart.bundle.min";
import { Bar, Pie } from "react-chartjs-2";

const Chart = require("chart.js");
Chart.elements.Rectangle.prototype.draw = function () {
  const ctx = this._chart.ctx;
  const vm = this._view;
  const left = vm.x - vm.width / 2;
  const right = vm.x + vm.width / 2;
  const top = vm.y;
  const bottom = vm.base;
  const radius = 6;

  ctx.beginPath();
  ctx.fillStyle = vm.backgroundColor;
  ctx.strokeStyle = vm.borderColor;
  ctx.lineWidth = vm.borderWidth || 0;

  ctx.moveTo(left, bottom);
  ctx.lineTo(left, top + radius);
  ctx.quadraticCurveTo(left, top, left + radius, top);
  ctx.lineTo(right - radius, top);
  ctx.quadraticCurveTo(right, top, right, top + radius);
  ctx.lineTo(right, bottom);
  ctx.closePath();
  ctx.fill();
  if (vm.borderWidth) ctx.stroke();
};

const FullReport = ({ data, type = "full" }) => {
  const pages = reportConfig[type] || [];
  const main = Array.isArray(data) ? data[0] : data;

  const formatValue = (item, value) => {
    if (value === null || value === undefined) return "";
    if (item.format?.type === "date") return moment(value).format("LL");
    if (item.format?.fn) return item.format.fn(value);
    if (item.format?.math) return item.format.math(value);
    return value;
  };

  const renderField = (item, value, index) => {
    if (!item) return null;

    if (item.type === "black" || item.type === "value") {
      const colorClass = item.type === "black" ? "text-dark" : "text-white";
      return (
        <span
          key={index}
          className={`absolute ${colorClass} ${item.className || ""}`}
        >
          {formatValue(item, value)}
          {item.format?.suffix || ""}
        </span>
      );
    }

    if (item.type === "barChart") {
      const barData = {
        labels: item.chart.labels,
        datasets: [
          {
            data: item.chart.datasetKeys.map((key) => getValue(value, key) || 0),
            backgroundColor: item.chart.backgroundColor || "#e9601a",
            maxBarThickness: 35,
          },
        ],
      };
      return (
        <div
          key={index}
          className={`absolute chart ${item.className || ""}`}
          style={item.chart.style}
        >
          <Bar data={barData} options={item.chart.options} />
        </div>
      );
    }

    if (item.type === "pieChart") {
      const pieData = {
        labels: item.chart.labels,
        datasets: [
          {
            data: item.chart.datasetKeys.map((key) => {
              const val = getValue(value, key);
              return val ? Math.round(val * 10000) / 100 : 1;
            }),
            backgroundColor:
              item.chart.backgroundColor || [
                "#ff6384",
                "#36a2eb",
                "#ffce56",
                "#4bc0c0",
                "#9966ff",
              ],
          },
        ],
      };
      return (
        <div
          key={index}
          className={`absolute chart ${item.className || ""}`}
          style={item.chart.style}
        >
          <Pie data={pieData} options={item.chart.options} />
        </div>
      );
    }

    return null;
  };

  return (
    <Card className="report">
      <CardBody>
        <div className="pdf">
          {pages.map((pageData, pIndex) => {
            const pageValue = pageData.dataKey
              ? getValue(main, pageData.dataKey) || {}
              : main;

            return (
              <div key={pIndex} className="pageToCapture">
                <img
                  src={pageData.pageName}
                  alt=""
                  className="img-fluid"
                />

                {Array.isArray(pageData.fields) &&
                  pageData.fields.map((item, fIndex) => {
                    const rawValue = item.key ? getValue(main, item.key) : pageValue;
                    return renderField(item, rawValue, fIndex);
                  })}

                {Array.isArray(pageData.career) &&
                  pageData.career.map((careerItem, cIndex) => {
                    const rawValue = getValue(main, careerItem.key);
                    return renderField(careerItem, rawValue, cIndex);
                  })}
              </div>
            );
          })}
        </div>
      </CardBody>
    </Card>
  );
};

export default FullReport;